import { render, staticRenderFns } from "./PhotographyAppointments.vue?vue&type=template&id=5a2b72d0&scoped=true&"
import script from "./PhotographyAppointments.vue?vue&type=script&lang=js&"
export * from "./PhotographyAppointments.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyAppointments.vue?vue&type=style&index=0&id=5a2b72d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2b72d0",
  null
  
)

export default component.exports